/* ============================================================
   Cart drawer — coupon / discount-code apply.
   Event-delegated on `document` so it survives the drawer's
   renderContents() DOM replacement (elements resolved lazily).

   Shopify has no AJAX "apply discount to cart" endpoint, so:
   1) GET /discount/{code} applies the code to the cart session
   2) /cart.js → cart.discount_codes[].applicable tells us if it stuck
   3) re-render the drawer via the Section Rendering API so the
      discount line + new total show (footer already lists them)
   ============================================================ */
(function () {
  'use strict';
  if (window.__cartCouponLoaded) return;
  window.__cartCouponLoaded = true;

  var busy = false;

  function statusEl(scope) { return scope.querySelector('[data-cart-coupon-status]'); }
  function setStatus(scope, msg, kind) {
    var el = statusEl(scope);
    if (!el) return;
    el.textContent = msg || '';
    el.className = 'cart-coupon__status' + (kind ? ' cart-coupon__status--' + kind : '');
  }

  function setBusy(scope, on) {
    busy = on;
    var btn = scope.querySelector('[data-cart-coupon-apply]');
    if (btn) { btn.disabled = on; btn.classList.toggle('cart-coupon__apply--loading', on); }
  }

  async function reRenderDrawer() {
    // Robust swap: never blank the drawer on a bad/empty response, and don't
    // call Dawn's renderContents (it throws once #CartDrawer has no .drawer__inner).
    var res = await fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble', { headers: { 'Accept': 'application/json' } });
    if (!res.ok) return;
    var data = await res.json();
    var drawerHtml = data['cart-drawer'];
    if (!drawerHtml) return;
    var doc = new DOMParser().parseFromString(drawerHtml, 'text/html');
    var fresh = doc.querySelector('#CartDrawer');
    var cur = document.querySelector('#CartDrawer');
    if (!fresh || !cur) return;
    cur.innerHTML = fresh.innerHTML;
    var bubbleHtml = data['cart-icon-bubble'];
    if (bubbleHtml) {
      var bdoc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
      var fb = bdoc.querySelector('.shopify-section') || bdoc.querySelector('#cart-icon-bubble');
      var cb = document.getElementById('cart-icon-bubble');
      if (fb && cb) cb.innerHTML = fb.innerHTML;
    }
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-coupon' });
      }
    } catch (e) {}
  }

  async function applyCoupon(scope) {
    if (busy) return;
    var input = scope.querySelector('.cart-coupon__input');
    if (!input) return;
    var code = (input.value || '').trim();
    if (!code) { setStatus(scope, 'יש להזין קוד קופון', 'error'); input.focus(); return; }

    setBusy(scope, true);
    setStatus(scope, '', '');
    try {
      // 1) apply the code to the session
      await fetch('/discount/' + encodeURIComponent(code), { headers: { 'Accept': 'text/html' } });
      // 2) check whether it actually applied
      var cart = await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })).json();
      var hit = (cart.discount_codes || []).filter(function (d) {
        return d.code && d.code.toLowerCase() === code.toLowerCase();
      })[0];

      if (hit && hit.applicable) {
        setStatus(scope, 'הקוד הוחל ✓', 'success');
        await reRenderDrawer();                 // discount line + new total now show
      } else {
        // applied to session but not reducing the cart now (e.g. BXGY / free-ship / min not met)
        setStatus(scope, 'הקוד אינו תקף לעגלה הזו', 'error');
      }
    } catch (e) {
      // network/parse failure → offer the hard fallback (applies + goes to checkout)
      setStatus(scope, 'שגיאה בהחלת הקוד — נסה שוב', 'error');
    } finally {
      setBusy(scope, false);
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-coupon-apply]');
    if (!btn) return;
    var scope = btn.closest('[data-cart-coupon]');
    if (scope) applyCoupon(scope);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('.cart-coupon__input');
    if (!input) return;
    e.preventDefault();
    var scope = input.closest('[data-cart-coupon]');
    if (scope) applyCoupon(scope);
  });
})();
